module.exports = __webpack_public_path__ + "static/media/barberscape-replacement-blade-1.11213b01.png";